var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNavigationMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-navigation-menu-vertical-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 3.79167C8.04712 3.79167 8.89591 2.94287 8.89591 1.89583C8.89591 0.848793 8.04712 0 7.00008 0C5.95304 0 5.10425 0.848793 5.10425 1.89583C5.10425 2.94287 5.95304 3.79167 7.00008 3.79167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 8.89583C8.04712 8.89583 8.89591 8.04704 8.89591 7C8.89591 5.95296 8.04712 5.10417 7.00008 5.10417C5.95304 5.10417 5.10425 5.95296 5.10425 7C5.10425 8.04704 5.95304 8.89583 7.00008 8.89583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 14C8.04712 14 8.89591 13.1512 8.89591 12.1042C8.89591 11.0571 8.04712 10.2083 7.00008 10.2083C5.95304 10.2083 5.10425 11.0571 5.10425 12.1042C5.10425 13.1512 5.95304 14 7.00008 14Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavigationMenu);
export default __webpack_public_path__ + "static/media/icon-navigation-menu.77eb88adff7a5c4e58e3b4f81bac7641.svg";
export { ForwardRef as ReactComponent };